import { Card, CardType } from "@wingspanhq/wingspan-api-sdk";
import React, { useEffect } from "react";
import { useWSModal, WSList, WSLoader } from "@wingspanhq/fe-component-library";
import { WSErrorMessage } from "../../../../components/WSErrorMessage/WSErrorMessage";
import { ErrorContextKey } from "../../../../services/platform";
import { queriesCards } from "@query";

type ActivateVirtualCardModalProps = {
  onClose: () => void;
  onSuccess: (card: Card) => void;
};

const CreateVirtualCardModal: React.FC<ActivateVirtualCardModalProps> = ({
  onClose,
  onSuccess
}) => {
  const [createCard, createCardMeta] = queriesCards.createCard.useMutation();

  useEffect(() => {
    createCard(
      {
        cardCreate: {
          cardType: CardType.VIRTUAL,
          // TODO; replace with actual address
          shippingAddress: {
            city: "New York",
            country: "US",
            line1: "123 Main St",
            state: "NY",
            postalCode: "10001"
          }
        }
      },
      {
        onSuccess: card => {
          onSuccess(card);
          onClose();
        }
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <WSList gap="L">
      {createCardMeta.error ? (
        <WSErrorMessage
          mb="XL"
          error={createCardMeta.error}
          contextKey={ErrorContextKey.RevealCardDataOPT}
        />
      ) : (
        <WSLoader.Spinner />
      )}
    </WSList>
  );
};

export const useCreateVirtualCardModal = () =>
  useWSModal(CreateVirtualCardModal, {
    title: "Activate virtual card",
    size: "S"
  });
